import { Box } from "@mui/material"
import type { SxProps } from "@mui/material"
import { useTheme } from "@mui/material/styles"

export default function SatellietLogoIcon({
  width,
  height,
  sx,
}: {
  width: number
  height: number
  sx?: SxProps
}) {
  const theme = useTheme()

  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        width: width,
        height: height,
        fill: theme.palette.text.primary,
        ...sx,
      }}
    >
      <svg
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
        version="1"
        viewBox="0 0 700 700"
      >
        <path
          d="M3278 6995c-1-1-42-6-89-9-47-4-94-8-105-10-10-2-45-7-78-11-67-8-105-14-126-20-8-3-32-7-54-11-155-24-417-101-631-186-308-122-723-366-900-530-16-15-33-28-37-28-5 0-8-4-8-9 0-6 279-289 325-330 2-2 32 19 67 46 279 219 646 408 984 507 50 15 99 28 110 30 10 3 58 14 105 25 203 48 361 64 629 65s318-2 520-35c353-57 675-171 1010-356 90-50 298-192 400-274 195-156 422-398 576-614 97-136 218-349 289-510 15-33 31-69 36-80 80-177 178-546 203-770 3-22 8-71 13-110 10-90 10-456 0-559-9-90-14-125-29-211-5-33-12-73-15-90-2-16-14-66-25-110s-21-87-23-96c-10-50-54-182-102-309-95-247-235-501-395-712-42-57-76-107-75-111 3-11 319-327 326-327 8 1 138 168 193 248 347 506 549 1058 611 1667 13 126 15 540 3 650-35 329-94 593-194 871-365 1015-1178 1806-2202 2140-164 54-386 108-535 130-27 4-57 9-65 10-8 2-44 6-80 10-36 3-78 8-95 11-33 5-531 13-537 8zM700 5603c-98-132-107-144-137-195-15-27-31-48-35-48-5 0-8-4-8-10 0-5-19-40-42-77-39-64-188-354-188-367 0-3-11-29-24-58-45-98-141-382-161-474-2-10-11-50-20-89-20-84-51-251-59-320-4-27-11-81-15-120-10-74-8-665 2-725 4-19 9-55 12-80 68-536 280-1087 588-1530 256-367 564-671 929-917 140-94 138-93 294-178 373-203 797-337 1251-395 122-15 200-18 448-15 165 2 329 8 365 13 36 6 85 13 110 16s54 8 65 10c62 11 103 19 122 22 249 46 610 172 874 304 179 90 468 274 574 364l40 35-164 164-165 165-105-74c-59-40-156-103-218-139-120-70-352-185-375-185-8 0-18-4-24-9-14-14-353-126-411-136-18-3-61-12-95-20-80-18-99-21-238-42-174-25-621-24-795 2-497 76-917 238-1305 503-621 424-1063 1064-1239 1794-34 141-62 315-77 476-15 168-6 471 21 652 39 271 101 499 201 744 48 116 149 322 187 378 12 18 34 53 49 78 14 25 56 87 93 139l67 93-33 35c-19 19-93 95-164 169l-131 134-64-87z"
          transform="matrix(.1 0 0 -.1 0 700)"
        ></path>
        <path
          d="M3417 5224c-1-1-44-4-95-8-448-30-826-258-977-590-56-123-70-194-70-356 0-167 4-199 40-298 93-258 291-420 670-546 61-21 218-64 350-97 495-122 621-169 728-272 74-71 92-116 92-227-1-113-21-167-90-235-139-140-454-188-788-120-91 18-215 86-285 155-89 87-138 195-149 328l-6 73-336-4-336-4v-64c-1-133 35-295 96-424 154-327 513-560 959-621 117-16 165-19 305-19 183 0 270 8 406 35 269 55 480 159 634 314 97 98 118 127 175 241 71 145 95 250 95 420-1 266-72 442-247 611-140 137-407 262-678 319-8 2-96 24-195 50-582 151-706 204-751 322-27 71-23 175 10 244 49 104 136 168 284 208 62 17 96 20 210 16 76-2 146-6 157-8 11-3 42-10 70-17 125-28 253-122 302-221 27-54 53-151 53-196v-32l68-3c37-2 190-2 341 0l274 3-6 82c-8 104-13 136-38 222-89 304-315 521-661 633-100 32-164 49-225 57-21 3-49 8-63 11-46 9-316 24-323 18z"
          transform="matrix(.1 0 0 -.1 0 700)"
        ></path>
      </svg>
    </Box>
  )
}
